import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointSuggestlistDetailTemplate]',
  standalone: true
})
export class QPointSuggestlistDetailTemplateDirective {
}
